import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Trans } from "react-i18next";
import Stopwatch from "./Stopwatch";
import Utility from "../utility/Utility";
import ClickToCall from "./ClickToCall";

type Props = {
  onCancel?: any;
  onYes?: any;
  messageKey?: any;
  titleKey?: string;
  cancelkey?: string;
  yesKey?: string;
  showRemainingTime?: boolean;
  onTimeUp?: any;
  onClose: any;
  isCenter?: any;
  hideNoButton?: boolean;
  comfirmMessage?: boolean;
  basicDetails?: any;
  language?: any;
  id_token?: string;
  name?: string;
  updateAsha?: boolean;
};

const ConfirmationModal = (props: Props) => {
  const handleTimeUp = async () => {
    props?.onTimeUp();
  };

  return (
    <Modal
      show={true}
      onHide={props.onClose}
      centered={props?.isCenter}
      backdrop={"static"}
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Trans i18nKey={props.titleKey} />
        </Modal.Title>
      </Modal.Header>
      {props.updateAsha === true ? (
        <Modal.Body>
          <span>
            <Trans i18nKey={"update_asha_details"} />
            <p>{props.name + "?"}</p>
          </span>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <ClickToCall
            page="conformationModal"
            messageKey={props?.messageKey}
          />
          {props.comfirmMessage && (
            <>
              <p>
                <Trans i18nKey="confirm_title" />
              </p>
              <span className="label-1">
                <Trans i18nKey="first_name" />:
              </span>{" "}
              {props.basicDetails.firstName}
              <br />
              <span className="label-1">
                <Trans i18nKey="gender" />:
              </span>{" "}
              <Trans i18nKey={props.basicDetails.gender}></Trans>
              <br />
              <span className="label-1">
                <Trans i18nKey="dob" />:
              </span>{" "}
              {Utility.formatDate(props.basicDetails.birthDate)} |{" "}
              {Utility.getAge(props.basicDetails.birthDate)}
              <br />
              <p className="mt-3 mb-0">
                <Trans i18nKey="confirm_continue" />
              </p>
            </>
          )}
          {props.showRemainingTime && (
            <Stopwatch miliseconds={59000} onTimeUp={handleTimeUp} />
          )}
        </Modal.Body>
      )}
      <Modal.Footer>
        {!props.hideNoButton && (
          <Button className="btn-outline me-3 no-btn" onClick={props.onCancel}>
            <Trans i18nKey={props.cancelkey} />
          </Button>
        )}

        <Button className="yes-btn" onClick={props.onYes}>
          <Trans i18nKey={props.yesKey} />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
